import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import CommonMenuBar from './menuBar2';

const HeaderWrapper = styled.div`
  position: fixed;
  z-index: 2;
  width: 100%;
  top: 0;

  ${(props) => {
    const { pathname, appType } = props;
    if (pathname.includes('/downloads/')) {
      return css`
        display: none;
      `;
    }
    if (appType === 'CRA' && pathname !== '/' && pathname !== '/about-us') {
      return css`
        position: sticky;
        top: 0;
      `;
    }

    return null;
  }}
`;

/**
 * This entire component needs to be cleaned up
 * from both cra and gatsby
 */
class Header extends Component {
  state = {
    hideHeader: false,
  };

  sideDrawerClosedHandler = () => {
    this.setState({ showSideDrawer: false });
  };

  sideDrawerToggleHandler = () => {
    this.setState((prevState) => ({
      showSideDrawer: !prevState.showSideDrawer,
    }));
  };

  setDrawerState = (_rightList, childrenList) => {
    this.setState({ childrenList });
  };

  render() {
    const {
      appType,
      MenuBar = CommonMenuBar,
      LinkComponent,
      HigherMobileToolbar,
      ProfileIcon,
      Notifications,
      MobileToolbar,
      CommonToolbar,
      ...userInfo
    } = this.props;
    const { hideHeader, childrenList, showSideDrawer } = this.state;

    return typeof window !== 'undefined' &&
      window &&
      !window.location.pathname.match(
        /documents\/[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/,
      ) ? (
      <>
        <HeaderWrapper
          pathname={window.location.pathname}
          appType={appType}
          hideHeader={hideHeader}
          data-testid="header-component"
        >
          <MenuBar
            appType={appType}
            userInfo={userInfo}
            pathname={window.location.pathname}
            setDrawerState={this.setDrawerState}
            sideDrawerToggleHandler={this.sideDrawerToggleHandler}
            childrenList={childrenList}
            showSideDrawer={showSideDrawer}
            LinkComponent={LinkComponent}
            ProfileIcon={ProfileIcon}
            Notifications={Notifications}
            MobileToolbar={MobileToolbar}
            CommonToolbar={CommonToolbar}
            HigherMobileToolbarRedux={HigherMobileToolbar}
          />
        </HeaderWrapper>

        {/* {rightList && !pathname.includes('/documents/') && (
          <HigherMobileToolbar
            rightList={rightList}
            pathname={pathname}
            showSideDrawer={showSideDrawer}
            user={user.user}
            userInfo={user}
            sideDrawerClosedHandler={this.sideDrawerClosedHandler}
            childrenList={childrenList}
            inviteId={inviteId}
          />
        )} */}
      </>
    ) : null;
  }
}

Header.propTypes = {
  isMenuOpen: PropTypes.bool,
  triggerMenu: PropTypes.func,
  user: PropTypes.shape({ user: PropTypes.object }),
  location: PropTypes.shape({ user: PropTypes.object }),
};

Header.defaultProps = {
  isMenuOpen: false,
  triggerMenu: () => {},
  user: undefined,
  location: null,
};

export default Header;
